module.exports = __webpack_public_path__ + "insert-variable.9344cc9087b8f1add3408a7c745b4731.hashedasset.svg";